import { styled, Text } from '@zeiss/beyond-online-react';

interface BaseReadOnlyFieldProps {
  title: string;
}

export type ReadOnlyFieldProps = BaseReadOnlyFieldProps &
  (
    | {
        children: React.ReactNode;
        text?: never;
      }
    | {
        children?: never;
        text: string;
      }
  );

const Container = styled.div`
  padding-top: var(--spacing-xs);
  padding-bottom: var(--spacing-xs);
`;

const StyledTitle = styled(Text)<{ $hasChildren?: boolean }>`
  padding-bottom: ${($hasChildren) =>
    /* istanbul ignore next -- @preserve */
    $hasChildren ? 'var(--spacing-xs)' : 'var(--spacing-2xs)'};
  margin: 0;
`;

const StyledText = styled(Text)`
  margin: 0;
  font-weight: 500;
  color: var(--color-global-text-strong);
`;

/**
 * Composition that mimics the various Beyond input designs to display content
 * that is read-only.
 *
 * Use this component when the `readonly` attribute on standard input components
 * is insufficient, as it retains undesirable visual elements like the search
 * icon, border, and focus styles.
 */
export const ReadOnlyField = ({
  children,
  text,
  title,
}: ReadOnlyFieldProps) => {
  return (
    <Container data-testid="ReadOnlyField">
      <StyledTitle $hasChildren={!!children} size="xs">
        {title}
      </StyledTitle>

      {children ?? <StyledText>{text}</StyledText>}
    </Container>
  );
};
